export default "__VITE_ASSET__BlRLZ4hl__"